var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { DataSourceTooltip } from "../../../components/DataSourceTooltip";
import { ShareCurrentViewButton } from "../../../shared/components/ShareCurrentViewButton";
import { LGBTQIA_CARD_WIDTH_BY_YEAR, LGBTQIA_SOURCE_URL, LGBTQIA_YEAR_OPTIONS, } from "../../../domains/lgbtqia/config/charts";
import { useLgbtqiaCharts } from "../../../domains/lgbtqia/hooks/useLgbtqiaCharts";
import { isMultiSeriesChart } from "../../../utils/chartData";
import { buildChartGridMdMap, ChartCard, getChartFamilyType, } from "../ChartCard";
export function LgbtqiaTab(_a) {
    var year = _a.year, onYearChange = _a.onYearChange, onDownloadToast = _a.onDownloadToast, onShareCopied = _a.onShareCopied;
    var charts = useLgbtqiaCharts(year);
    var displayCharts = charts;
    var widthOverrides = Object.fromEntries(displayCharts
        .map(function (chart, index) {
        var _a;
        var width = (_a = LGBTQIA_CARD_WIDTH_BY_YEAR[year]) === null || _a === void 0 ? void 0 : _a[chart.title];
        return width == null ? null : [index, width];
    })
        .filter(function (entry) { return entry != null; }));
    var chartGridMdMap = buildChartGridMdMap(displayCharts, {
        lgbtqiaWidthOverrides: widthOverrides,
    });
    return (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ sx: {
                    width: "100%",
                    mt: 1,
                    mb: 2.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 3,
                    flexWrap: "wrap",
                    borderBottom: 1,
                    borderColor: "divider",
                } }, { children: [_jsx(Tabs, __assign({ value: year, onChange: function (_, value) { return onYearChange(value); }, sx: {
                            "& .MuiTab-root": {
                                textTransform: "none",
                                fontFamily: "Montserrat, sans-serif",
                                fontWeight: 500,
                                fontSize: "0.9rem",
                                color: "#6B7280",
                                minWidth: "auto",
                                px: 2,
                                "&.Mui-selected": { color: "#034EA2", fontWeight: 700 },
                            },
                            "& .MuiTabs-indicator": {
                                backgroundColor: "#034EA2",
                                height: 2,
                            },
                        } }, { children: LGBTQIA_YEAR_OPTIONS.map(function (option) { return (_jsx(Tab, { value: option, label: option }, option)); }) })), _jsxs(Box, __assign({ sx: {
                            ml: "auto",
                            pb: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            flexWrap: "wrap",
                            justifyContent: "flex-end",
                        } }, { children: [_jsx(DataSourceTooltip, { base: "Boletim de Dados de Viol\u00EAncia contra LGBTQIA+ (2022-2023)", description: "Fonte: Secretaria de Seguran\u00E7a P\u00FAblica do Piau\u00ED (SSP PI)", link: LGBTQIA_SOURCE_URL }), _jsx(ShareCurrentViewButton, { onCopied: onShareCopied })] }))] })), _jsx(Grid, __assign({ container: true, spacing: 2.5 }, { children: displayCharts.map(function (chart, index) {
                    var _a, _b, _c;
                    var effectiveChartType = (_a = chart.chartType) !== null && _a !== void 0 ? _a : (_b = chart.data) === null || _b === void 0 ? void 0 : _b.chart;
                    var chartFamilyType = getChartFamilyType(effectiveChartType);
                    var isMultiSeries = chart.data != null &&
                        isMultiSeriesChart(chart.data, chartFamilyType);
                    return (_jsx(Grid, __assign({ item: true, xs: 12, md: (_c = chartGridMdMap[index]) !== null && _c !== void 0 ? _c : 6 }, { children: _jsx(ChartCard, { chart: chart, onDownloadToast: onDownloadToast, mobileLegendList: isMultiSeries || chartFamilyType === "bar" }) }), "".concat(year, "-").concat(chart.id)));
                }) }))] }));
}
